import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ImageService } from '../../../../../services/image/image.service';
import { FormatService } from '../../../../../common/format/format.service';

@Component({
  selector: 'brief-feed-hired',
  standalone: true,
  imports: [],
  templateUrl: './feed-hired.component.html',
  styleUrl: './feed-hired.component.css'
})
export class FeedHiredComponent {
  @Input('activity') activity: any;
  @Output() viewHiresOut = new EventEmitter<void>();

  /** Services */
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  /** Services END */

  viewHires() {
    console.log('viewHires()');
    if (this.activity.briefApplications.length > 0) {
      this.viewHiresOut.emit();
    }
  }

  onCardKeydown(event: Event): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.key !== 'Enter' && keyEvent.key !== ' ') {
      return;
    }
    if (keyEvent.key === ' ') {
      keyEvent.preventDefault();
    }
    this.viewHires();
  }
}
